import config from '@/common/config'
import tool from '@/common/tool'
import urlsData  from './data/urls';
let urls = {};
let host = tool.isLocal() ? config.localhost : config.host;
function mergeURL(url){
    if(/^http|^https/.test(url)) return url;
    return `${host}${config.urlPrefix}${url}`;
}
for(let key in urlsData){
    if(typeof urlsData[key] == "object"){
        urls[key] = {}
        for(let i in urlsData[key]){
            urls[key][i] =  mergeURL(urlsData[key][i]);
        }
        continue
    }
    urls[key] = mergeURL(urlsData[key]);
}
export default urls;


